import { ParsedItem } from 'store/declaration-form-errors/ParsedForm';

// An item path through a repeated parent (`consignment.houseConsignment.x.consignmentItem`) names
// the items of every parent at once, so an error index does not point at one array.
const PLACEHOLDER_SEGMENT = '.x.';

/**
 * The parsers number an error item by its position in the validated items array. The products
 * table is sorted, paged and changes as items are added or deleted, so a position means nothing
 * there. The id of the item at that position does.
 */
const attachItemIds = (
    items: ParsedItem[],
    itemsWithIds: { id?: string }[] = [],
    itemPath: string | undefined
): ParsedItem[] => {
    if (!itemPath || itemPath.includes(PLACEHOLDER_SEGMENT)) return items;

    return items.map((item) => ({ ...item, id: itemsWithIds[item.index - 1]?.id }));
};

export default attachItemIds;
